/* Lädt auf allen Seiten – außer der Startseite */
document.addEventListener('DOMContentLoaded', () => {

  /* ---------- Startseite ausklammern ---------- */
  if (
       Shopify?.theme?.pageType === 'index' ||   // gängige Dawn-Kennung
       window.location.pathname === '/'          // Fallback
     ){
    return;                                     // sofort beenden
  }

  const wrapper = document.querySelector('sticky-header.header-wrapper');
  if (wrapper) {
    const toggle = () =>
      wrapper.classList.toggle('has-shadow', window.scrollY > 0);

    toggle();                                   // Zustand sofort prüfen
    window.addEventListener('scroll', toggle, { passive: true });
  }
});
